module.exports = __webpack_public_path__ + "img/jobmule_ricerca3.d29ed987.png";